import { createRequest } from './createRequest'

export const evaluationGetPath = '/evaluation/get'
export const evaluationGet = createRequest({ path: evaluationGetPath })

export const evaluationListPath = '/evaluation/list'
export const evaluationList = createRequest({ path: evaluationListPath })

export const evaluationDeletePath = '/evaluation/delete'
export const evaluationDelete = createRequest({ path: evaluationDeletePath })
